<sgt-select
  [options]="options"
  [settings]="settings"
  [ngModel]="value"
  (selectedValueChanged)="onChanged($event)"
>
</sgt-select>

<small class="form-text text-muted">
  Selecione o nível de acesso às informações de resultado e lucratividade dos pedidos
</small>

<small class="form-text text-muted" style="font-weight: 600;" *ngIf="descricaoNivelSelecionado">
  {{ descricaoNivelSelecionado }}
</small>
